export default __webpack_public_path__ + "static/arithmenillustrations-06-49c3c2590de63f43d48ebbab26592f69.png";